import type { AppRouteRecordRaw } from '/@/router/types'
import {
  REDIRECT_NAME,
  LAYOUT,
  EXCEPTION_COMPONENT,
  PAGE_NOT_FOUND_NAME,
  PAGE_NOT_AUTH_NAME,
} from '/@/router/constant'

// 404 on a page
export const PAGE_NOT_FOUND_ROUTE: AppRouteRecordRaw = {
  path: '/:path(.*)*',
  name: 'not_found',
  component: LAYOUT,
  meta: {
    title: 'ErrorPage',
    hideBreadcrumb: true,
    hideMenu: true,
  },
  children: [
    {
      path: '/:path(.*)*',
      name: PAGE_NOT_FOUND_NAME,
      component: EXCEPTION_COMPONENT,
      meta: {
        title: 'ErrorPage',
        hideBreadcrumb: true,
        hideMenu: true,
      },
    },
  ],
}

export const REDIRECT_ROUTE: AppRouteRecordRaw = {
  path: '/redirect',
  component: LAYOUT,
  name: 'RedirectTo',
  meta: {
    title: REDIRECT_NAME,
    hideBreadcrumb: true,
    hideMenu: true,
  },
  children: [
    {
      path: '/redirect/:path(.*)',
      name: REDIRECT_NAME,
      component: () => import('/@/views/sys/redirect/index.vue'),
      meta: {
        title: REDIRECT_NAME,
        hideBreadcrumb: true,
      },
    },
  ],
}

export const NOAUTH_ROUTE: AppRouteRecordRaw = {
  path: '/unauth',
  name: PAGE_NOT_AUTH_NAME,
  component: () => import('/@/views/sys/unauth/index.vue'),
  meta: {
    title: PAGE_NOT_AUTH_NAME,
    hideBreadcrumb: true,
    hideMenu: true,
  },
}

export const MAINTENANCE_ROUTE: AppRouteRecordRaw = {
  path: '/maintenance',
  name: 'maintenance_page',
  component: () => import('/@/views/sys/maintenance/index.vue'),
  meta: {
    title: 'maintenance_page',
    hideBreadcrumb: true,
    hideMenu: true,
  },
}

export const PERMISSION_EXCEPTION: AppRouteRecordRaw = {
  path: '/permission-exception',
  name: 'permission-exception',
  component: () => import('/@/views/sys/permission-exception/index.vue'),
  meta: {
    title: 'permission-exception',
    hideBreadcrumb: true,
    hideMenu: true,
    ignoreAuth: true,
  },
}

// 全国视角
export const dashboardNationalRoute: AppRouteRecordRaw = {
  path: '/dashboard',
  name: 'dashboard',
  component: () => import('/@/views/dashboard/index.vue'),
  meta: {
    title: 'Dashboard',
    ignoreLayout: true, // 不自动包装 LAYOUT
  },
}

export const redirectDashboardRoute: AppRouteRecordRaw = {
  path: '/:lang/dashboard',
  name: 'redirectDashboard',
  redirect: '/dashboard',
  meta: {
    title: 'redirectDashboard',
    hideBreadcrumb: true,
    hideMenu: true,
  },
}

// RAAS 接管人车比 BI 看板
export const biDashboardRoute: AppRouteRecordRaw = {
  path: '/bi-dashboard',
  name: 'bi-dashboard',
  component: () => import('/@/views/bi-dashboard/index.vue'),
  meta: {
    title: 'RAAS BI 看板',
    ignoreLayout: true,
  },
}

export const loginRoute: AppRouteRecordRaw = {
  path: '/login',
  name: 'login',
  component: () => import('/@/views/login/index.vue'),
  meta: {
    title: 'Login',
    ignoreLayout: true, // 不自动包装 LAYOUT
  },
}
